<script>
import {tableRelevant} from "@/pages/projectImpl/js/utils";
import RelevanceOrg from "./relevanceOrg.vue";

export default {
  name: "childTable",
  props: {
    seriesInfo: Object,
  },
  components: {RelevanceOrg},
  data() {
    return {
      columns: [
        {title: '资源包名称', scopedSlots: {customRender: 'name'}},
        {title: '资源个数', dataIndex: "count", width: 100},
        {title: '文件大小', scopedSlots: {customRender: 'size'}, width: 100},
        {title: '关联机构', scopedSlots: {customRender: 'usageCount'}, width: 100},
        {title: '更新时间', dataIndex: 'updateTime', width: 120},
        {title: '创建时间', dataIndex: 'createTime', width: 120},
        {title: '状态', scopedSlots: {customRender: 'enabled'}, width: 100},
        {title: '操作', scopedSlots: {customRender: 'action'}, width: 170},
      ],
      table: tableRelevant.call(this),
      resource: {
        visible: false,
        info: {}
      }
    };
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    getPageList() {
      this.table.tableLoading = true;
      this.$http.CourseResource.ResourcePackagePagelist({
        seriesId: this.seriesInfo.id,
        pageIndex: 1,
        pageSize: 9999,
      }).then(({data}) => {
        this.table.tableDataSource = data.items;
        this.$http.CourseService.ResourcePackageUsages({packageIds: data.items.map(item => item.id)}).then(res => {
          this.table.tableDataSource = data.items.map(m => {
            const item = res.data.find(item => item.resourcePackageId === m.id) || {};
            return {...m, ...item};
          });
        });
      }).finally(() => {
        this.table.tableLoading = false;
      });
    },
    changeStatus(val) {
      this.$store.commit("course/setSeriesInfo", this.seriesInfo);
      const Params = {
        status: !val.enabled,
        id: val.id,
      };
      if (Params.status) {
        this.table.tableLoading = true;
        this.$http.CourseResource.ResourcePackageEnabled(val.id, Params).then(res => {
          this.$message.success(res.message);
          val.enabled = !val.enabled;
        }).finally(() => {
          this.table.tableLoading = false;
        });
        return;
      }
      this.$confirm({
        title: '提示',
        content: '关闭后，已配置的机构将无法查看该资源，请谨慎操作',
        okText: '确认关闭',
        centered: true,
        okType: 'danger',
        onOk: () => {
          this.table.tableLoading = true;
          this.$http.CourseResource.ResourcePackageEnabled(val.id, Params).then(res => {
            this.$message.success(res.message);
            val.enabled = !val.enabled;
          }).finally(() => {
            this.table.tableLoading = false;
          });
        },
      });

    },
    edit(record) {
      this.$store.commit("course/setSeriesInfo", this.seriesInfo);
      this.$router.push({
        path: '/course/resources/ae',
        query: {
          id: record.id,
          params: JSON.stringify(record),
        },
      });
    },
    remove(record){
      this.table.tableLoading = true;
      this.$http.CourseResource.RemovePackage({resourcePackageIds: [record.id]}).then(res => {
        this.$message.success(res.message)
        this.getPageList();
      }).catch(() => {
        this.table.tableLoading = false;
      });
    },
    del(record) {
      if (record.usageCount > 0) {
        this.$confirm({
          title: '提示',
          content: h => h('div', {}, [
            '有 ',
            h('span', {style: {color: 'red'}}, record.usageCount),
            ' 个机构正在使用该资源，删除后机构将无法使用该资源，请谨慎操作',
          ]),
          okText: '确认删除',
          centered: true,
          okType: 'danger',
          onOk: () => {
            this.table.tableLoading = true;
            this.$http.CourseResource.ResourcePackageDelete(record.id).then(res => {
              this.$message.success(res.message)
              this.getPageList();
            }).catch(() => {
              this.table.tableLoading = false;
            });
          },
        });
        return;
      }
      this.$confirm({
        title: '确认要删除该资源吗？',
        centered: true,
        okType: 'danger',
        onOk: () => {
          this.table.tableLoading = true;
          this.$http.CourseResource.ResourcePackageDelete(record.id).then(res => {
            this.$message.success(res.message)
            this.getPageList();
          }).catch(() => {
            this.table.tableLoading = false;
          });
        },
      });
    },
    relevanceShow(val) {
      this.resource = {
        visible: true,
        info: val,
      }
    },
  },
};
</script>

<template>
  <div>
    <a-table rowKey="id" :columns="columns" :data-source="table.tableDataSource" :loading="table.tableLoading"
             :pagination="false">
      <div slot="name" slot-scope="text">
        <img :src="text.icon | filterUrl" alt="" style="width: 24px; height: 24px;object-fit: cover;">
        {{text.name}}
      </div>
      <a-switch slot="enabled" slot-scope="text" :checked="text.enabled"
                @click="changeStatus(text)"
                v-auth="`enabled-resource`"
                checked-children="启用"
                un-checked-children="禁用"/>
      <a-button type="link" slot="usageCount" slot-scope="text" @click="relevanceShow(text)">{{ text.usageCount || 0 }}</a-button>
      <div slot="size" slot-scope="text">
        <span>{{ text.size || '--' }}</span>
      </div>
      <div slot="action" class="action" slot-scope="text">
        <a v-permission="`/course/resources/ae`" href="javaScript:;" @click="edit(text)">编辑</a>
        <a-popconfirm v-permission="`remove-resource`" title="确认移除资源包?" @confirm="remove(text)">
          <a href="javaScript:;">移除</a>
        </a-popconfirm>
        <a v-permission="`delete-resource`" class="red" @click="del(text)">删除</a>
      </div>
    </a-table>
    <relevance-org v-model="resource.visible" :resource="resource.info" :series-info="seriesInfo"/>
  </div>
</template>

<style scoped lang="less">

</style>
